import { useCallback } from 'react';
import type { GoodsCoreModel, IScreensLogging } from '../../../../../api/types';
import { bridge, isNotNil } from '../../../../../utils';
import { AdAction } from '../../../../../utils/eventLogger/adLogger/types';
import { useAtomicScreen } from '../../../context/AtomicScreenContext';

type LogOnGoodsPressItemParams = {
  item: GoodsCoreModel;
  logging: IScreensLogging;
};

export const useLogOnGoodsPressItem = () => {
  const screen = useAtomicScreen();

  return useCallback(
    ({ item, logging }: LogOnGoodsPressItemParams) => {
      bridge.logAnalyticsEvent({
        name: 'CLICK_GOODS',
        analytics: {
          ...logging.analytics,
          ...(screen != null && { SCREEN: screen }),
        },
        ably_only_log: logging.ably_only_log,
      });

      if (isNotNil(item.ad)) {
        bridge.logAdEvent({
          action: AdAction.CLICK,
          ad: item.ad,
        });
      }
    },
    [screen],
  );
};
